import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';

interface BackButtonProps {
  text?: string;
  onClick?: () => void;
  sx?: object;
}

const BackButton: React.FC<BackButtonProps> = ({ text = 'Voltar', onClick, sx = {} }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(-1);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, ...sx }}>
      <Button
        startIcon={<ArrowBackIcon sx={{ fontSize: 18 }} />}
        sx={{
          color: '#4460ff',
          textTransform: 'none',
          fontSize: '0.875rem',
          fontWeight: 'normal',
          padding: '0',
        }}
        onClick={handleClick}
      >
        {text}
      </Button>
    </Box>
  );
};

export default BackButton;
